import React from 'react';
import AdminTable from './TableAdmin/TableAdmin';

const Admin = () => {
  return <AdminTable/> ;
};

export default Admin;
